<template>
  <div class="pt-8 pl-8" style="width: 100%">
    <div class="pb-4 text-h2" style="width: 50%">Web of Buildings</div>
    <div class="pb-2 text-h5 font-weight-light" style="width: 30%">
      Value Creation with Data. Day to Day Business and Transactions.
      RealEstateCore. Digital Twins. Open Web Technologies. Welcome to Web of
      Buildings.
    </div>
    <div class="pb-2 text-h5 font-weight-light" style="width: 30%">
      This is an experimental version of the WoB Explorer. It is used to digest
      RealEstateCore based digital twins.
    </div>
    <v-btn large color="primary" to="/search">
      <v-icon color="secondary" left>mdi-home-city</v-icon>Get started</v-btn
    >
  </div>
  <!--
  <v-card width="50%">
    <v-card-text class="text-h2"
      >Welcome to the Web of Buildings Explorer</v-card-text
    >
    <v-card-text class="text-body-1"
      >This is an experimental version of the WoB Explorer. At a later stage
      background for WoB goes here.</v-card-text
    >
    <v-divider></v-divider>
    <v-card-actions class="justify-end">
      <v-btn color="secondary" to="/search"
        >Get started <v-icon>mdi-office-building-outline</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
  -->
</template>

<script>
export default {
  component: 'WelcomeMessage',
}
</script>
